var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84194 15.8941H0V3.57861H8.84194V15.8941ZM0.631609 15.2625H8.21033V4.21025H0.631609V15.2625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4208 14.6308H8.68403V13.9994H9.78923V2.63097H1.8947V3.76781H1.26312V1.99951H10.4209L10.4208 14.6308Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.3681H10.2947V12.7365H11.3684V1.3684H3.63159V2.50523H3.00002V0.736816H12L11.9999 13.3681Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89468 5.47333H5.05244V6.10491H1.89468V5.47333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89468 7.05219H6.94726V7.68377H1.89468V7.05219Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89468 8.63129H6.94726V9.26287H1.89468V8.63129Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89468 9.89441H6.94726V10.526H1.89468V9.89441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon1);
export default __webpack_public_path__ + "static/media/Step_Icon_1.9910f0130b5113f92bf01203ad19e526.svg";
export { ForwardRef as ReactComponent };